import { SerializedChecklistContents } from "../../lib/model/checklistSerialized";

export const emptyChecklist: SerializedChecklistContents = {
  title: "",
  checklists: [],
};
